class MgmStickyAddToCart extends HTMLElement {
  connectedCallback() {
    this.mainButton = this.getMainAddToCartButton();
    this.mainQuantitySelector = this.getMainQuantitySelector();
    this.stickyQuantityInput = this.querySelector('[data-mgm-sticky-quantity]');
    this.stickyButton = this.querySelector('[data-mgm-sticky-button]');

    this.stickyButton?.addEventListener('click', this.onAddToCartClick.bind(this));
    this.stickyQuantityInput?.addEventListener('change', this.onStickyQuantityChange.bind(this));

    this.observeMainButton();
    this.syncFromMainQuantity();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  getMainAddToCartButton() {
    const section = this.closest('.shopify-section') || document;
    return section.querySelector('product-form-component add-to-cart-component button[name="add"]');
  }

  getMainQuantitySelector() {
    const section = this.closest('.shopify-section') || document;
    return section.querySelector('product-form-component quantity-selector-component');
  }

  observeMainButton() {
    if (!this.mainButton) {
      this.classList.add('mgm-sticky-add-to-cart--visible');
      return;
    }

    this.observer = new IntersectionObserver(
      ([entry]) => {
        const shouldShow = !entry.isIntersecting && window.scrollY > 240;
        this.classList.toggle('mgm-sticky-add-to-cart--visible', shouldShow);
      },
      { threshold: 0.01 }
    );

    this.observer.observe(this.mainButton);
  }

  syncFromMainQuantity() {
    if (!(this.stickyQuantityInput instanceof HTMLInputElement)) return;

    const mainInput = this.mainQuantitySelector?.querySelector('input[name="quantity"]');
    if (!(mainInput instanceof HTMLInputElement)) return;

    this.stickyQuantityInput.value = mainInput.value || '1';
    this.stickyQuantityInput.min = mainInput.min || '1';
    this.stickyQuantityInput.step = mainInput.step || '1';

    if (mainInput.max) {
      this.stickyQuantityInput.max = mainInput.max;
    }
  }

  onStickyQuantityChange() {
    if (!(this.stickyQuantityInput instanceof HTMLInputElement)) return;

    this.setMainQuantity(Number(this.stickyQuantityInput.value));
  }

  setMainQuantity(quantity) {
    if (!Number.isFinite(quantity) || quantity < 1) return;

    const mainInput = this.mainQuantitySelector?.querySelector('input[name="quantity"]');
    if (!(mainInput instanceof HTMLInputElement)) return;

    const min = Number(mainInput.min) || 1;
    const max = Number(mainInput.max);
    const step = Number(mainInput.step) || 1;
    let nextQuantity = Math.max(min, quantity);

    if (Number.isFinite(max) && max > 0) {
      nextQuantity = Math.min(max, nextQuantity);
    }

    if (step > 1) {
      nextQuantity = min + Math.round((nextQuantity - min) / step) * step;
    }

    if (typeof this.mainQuantitySelector?.setValue === 'function') {
      this.mainQuantitySelector.setValue(String(nextQuantity));
      this.mainQuantitySelector.onQuantityChange?.();
      this.mainQuantitySelector.updateButtonStates?.();
    } else {
      mainInput.value = String(nextQuantity);
      mainInput.dispatchEvent(new Event('input', { bubbles: true }));
      mainInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (this.stickyQuantityInput instanceof HTMLInputElement) {
      this.stickyQuantityInput.value = String(nextQuantity);
    }
  }

  onAddToCartClick() {
    this.syncMainState();
    this.mainButton?.click();
  }

  syncMainState() {
    if (this.stickyQuantityInput instanceof HTMLInputElement) {
      this.setMainQuantity(Number(this.stickyQuantityInput.value));
    }

    const disabled = this.mainButton instanceof HTMLButtonElement && this.mainButton.disabled;
    if (this.stickyButton instanceof HTMLButtonElement) {
      this.stickyButton.disabled = disabled;
    }
  }
}

if (!customElements.get('mgm-sticky-add-to-cart')) {
  customElements.define('mgm-sticky-add-to-cart', MgmStickyAddToCart);
}

